import {Action, ActionType} from './actions'
import {PammInvestorAccount} from './getPammInvestorCardState'

export type State = {
  account: PammInvestorAccount;
  showMinimumDepositRequiredPopup: boolean;
  showTransferNeededPopup: boolean;
  showPendingPopup: boolean;
}

export const reducer = (state: State, action: Action) => {
  switch (action.type) {
    case ActionType.Click: {
      const {isDepositNeeded, isTransferNeeded, isUnapproved} = action.payload

      if (isDepositNeeded) {
        return {
          ...state,
          showMinimumDepositRequiredPopup: true,
        }
      }
      if (isTransferNeeded) {
        return {
          ...state,
          showTransferNeededPopup: true,
        }
      }
      if (isUnapproved) {
        return {
          ...state,
          showPendingPopup: true,
        }
      }
      return state
    }
    case ActionType.CloseModal: {
      return {
        ...state,
        showMinimumDepositRequiredPopup: false,
        showTransferNeededPopup: false,
        showPendingPopup: false,
      }
    }
    default: {
      return state
    }
  }
}
